import { render, staticRenderFns } from "./ReportV2.vue?vue&type=template&id=1b2a2c5e&scoped=true&"
import script from "./ReportV2.vue?vue&type=script&lang=js&"
export * from "./ReportV2.vue?vue&type=script&lang=js&"
import style0 from "./ReportV2.vue?vue&type=style&index=0&id=1b2a2c5e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b2a2c5e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VOverlay } from 'vuetify/lib/components/VOverlay';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSnackbar } from 'vuetify/lib/components/VSnackbar';
installComponents(component, {VBtn,VCol,VOverlay,VProgressCircular,VRow,VSnackbar})
